import { AppTemplate } from 'features/templates/types'

export function useAppTemplateIconState(template: AppTemplate) {
    const { name } = template

    const initial = name.slice(0, 1).toUpperCase()

    return { initial }
}
